var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCubic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a { fill: currentColor; }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.194,12.008L0.357,7.024a.257.257,0,0,0-.357.237v13.324a.823.823,0,0,0,.518.765L12,25.942a.257.257,0,0,0,.353-.239V12.245A.257.257,0,0,0,12.194,12.008Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.275,10.593l11.441-4.818a.257.257,0,0,0,.009-.47l-11.2-5.228a.824.824,0,0,0-.7,0l-11.2,5.228a.257.257,0,0,0,.009.47l11.441,4.818a.257.257,0,0,0,.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.998,12.245v13.458a.257.257,0,0,0,.353.239l11.481-4.592a.823.823,0,0,0,.518-.765V7.261a.257.257,0,0,0-.357-.237l-11.837,4.984A.257.257,0,0,0,13.998,12.245Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubic);
export default __webpack_public_path__ + "static/media/cubic.441f0764521008e4532d398083ed54e4.svg";
export { ForwardRef as ReactComponent };